import React, { Component } from  'react';
import {
  Modal, Button
} from 'react-bootstrap'
import './css/AnimViewModal.css'
import AnimContainer from './AnimContainer';


class AnimViewModal extends Component {

  render() {
    return <div id="test" className="hide">
      <Modal
        size="lg"
        show={this.props.modalShow}
        onHide={this.props.onHide}
        aria-labelledby="example-modal-sizes-title-lg"
        id="animViewModal"
        >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <AnimContainer
            sSpec={(this.props.sequence || [{}])[0]}
            sequence={this.props.sequence || []}
            animationSpecs={this.props.animationSpecs || []}
            showMetaInfo={false}
            height={"100%"}
            id="animViewInModal"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={this.props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  }


}

export default AnimViewModal;
